import { EventProperties } from '@calm/evexia-analytics';
import { Link } from '@rhg/libs/material';
import NextLink from 'next/link';
import { Ref, forwardRef } from 'react';

export type CHLinkProps = React.ComponentProps<typeof Link> &
    React.ComponentProps<typeof NextLink> & {
        trackButton?: string;
        trackProps?: EventProperties;
    };

export default forwardRef(function CHLink(
    props: CHLinkProps,
    ref: Ref<HTMLAnchorElement>
) {
    // We need to remove these props because they throw an error when rendered.
    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    const { trackButton: _1, trackProps: _2, ...otherProps } = props;
    return <Link ref={ref} {...otherProps} component={NextLink} />;
});
